/* The next few technicians for a piece of work, soonest first.
 *
 * The board names one person on every Next availability row and every Due now
 * chip. That answer is the right one to show — it is who the work goes to — but
 * the question the desk asks next is "and if not her?", and the board knows the
 * answer: everybody who could do it, and the soonest each of them has room.
 * The hover card lists the first three.
 *
 * The first is never re-decided here. It is whoever the row or the chip already
 * names (`leadId`), so the card and the thing it opened from cannot disagree
 * about who is next — the chip's pick has rules of its own (a request, the book's
 * own technician) that a plain sort by time would overrule. Everybody after it
 * is in order of when they could start, with a tie going to the rotation, the
 * same tie-break the Next line uses.
 *
 *   candidates  [{ id, at, rank, ... }] — `at` the soonest they could start, or
 *               null when the board cannot say (bypassed, a square with no
 *               expected end, no day left). `rank` their place in the
 *               rotation, or null for somebody not on it.
 *   leadId      who the row names, or null.
 *   limit       how many to return.
 *
 * Returns the candidate objects themselves, untouched, in order. Pure; this file
 * imports nothing.
 */
export function nextByTime(candidates, leadId, limit) {
  var list = candidates || [];
  var n = limit == null ? 3 : limit;
  var lead = leadId == null ? null
    : list.find(function (c) { return c.id === leadId; }) || null;
  var rest = list
    .filter(function (c) { return c !== lead && c.at != null; })
    .sort(function (a, b) {
      return (a.at - b.at) || (rankOf(a) - rankOf(b));
    });
  return (lead ? [lead] : []).concat(rest).slice(0, Math.max(0, n));
}

function rankOf(c) { return c.rank == null ? Infinity : c.rank; }
